import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useRef} from 'react';
import './nav.css'
import '../App.css'
//
import Logo from '../svgs/Logo.js'
import BookArrowSvg from '../svgs/home/BookArrowSvg.js'
import BookArrowWhite from '../svgs/home/BookArrowWhite.js'
import { connect } from 'react-redux';
import CONTENT from '../contents/nav'
import BTN from '../contents/btn.js'
import NewLogoTop from '../svgs/NewLogoTop.js'
//
import {useLang} from '../hook/UseLang.js'
const Nav = ({scrollRef, handleSetRightNav, onlyIcon=false,control}) => {
    const location = useLocation()
    const [curScreen, setCurScreen] = useState('/')
    const refToScroll = useRef(null)
    const [isScrolled, setIsScrolled] = useState(false)
    const [relative, setRelative] = useState('')
    //
    const navigate = useNavigate()
    const navigating = (path) => navigate(path)
    const [lang, setLang] = useLang()
    useEffect(() => {
        setCurScreen(location.pathname)
        if(location.pathname === '/newlanding/'){
            setRelative('./')
        }else{
            setRelative('../')
        }
    }, [location])
    
    function scrolling(){
        refToScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
    
    useEffect(() => {
        if(!scrollRef?.current) return;
        const controller = new AbortController()

        scrollRef.current.addEventListener('scroll', () => {
        setIsScrolled(scrollRef.current.scrollTop > 0)
        }, { signal: controller.signal });
        
        return () => {
            controller.abort()
        };
    }, []);

    
    return (
        <>
            <div ref={refToScroll} className='w-full h-[103px] flex justify-between items-center absolute top-0 left-0 px-[48px]' style={{zIndex:99999,backgroundColor:curScreen==='/'?'transparent':'white',opacity:control?.hideMenu?0:1,transition:'all .5s ease'}}>
                <div className='w-full h-full d-show-m-hidden flex flex-row items-center justify-between' style={{zIndex:99999}}>
                    <div className='h-full flex flex-row items-center justify-start' style={{flex:1}}>
                        <div className='flex flex-row items-center justify-between d-show-m-hidden p-8 cursor-pointer select-none' onClick={() => handleSetRightNav(true)}>
                            <div className='flex flex-col items-center justify-center w-[44px] cursor-pointer select-none' style={{gap:4}}>
                                <div className='h-[1px] w-full bg-[#9D968D]'></div>
                                <div className='h-[1px] w-full bg-[#9D968D]'></div>
                                <div className='h-[1px] w-full bg-[#9D968D]'></div>
                            </div>
                        </div>
                    </div>
                    <div onClick={() => navigating(`/?lang=${lang}`)} className='h-full flex flex-row items-center justify-center cursor-pointer' style={{flex:1}}>
                        <div className='logo-size'>
                            <NewLogoTop />
                        </div>
                    </div>
                    <div className='h-full flex flex-row items-center justify-end' style={{flex:1, gap:2}}>
                        <div className='flex flex-row items-center justify-center d-show-m-hidden'>
                            <div onClick={() => {setLang('en')}} className='cursor-pointer select-none px-[28px] py-[4px] text-[#9D968D] text-d-12 hover:font-bold' style={{fontWeight:lang === 'en' ? 800 : ''}}>Eng</div>
                            <div className='h-[16px] w-[1px] bg-[#9D968D]'></div>
                            <div onClick={() => {setLang('sc')}} className='cursor-pointer select-none px-[28px] py-[4px] text-[#9D968D] text-d-12 hover:font-bold' style={{fontWeight:lang === 'sc' ? 800 : ''}}>简体</div>
                            <div className='h-[16px] w-[1px] bg-[#9D968D]'></div>
                            <div onClick={() => {setLang('tc')}} className='cursor-pointer select-none px-[28px] py-[4px] text-[#9D968D] text-d-12 hover:font-bold' style={{fontWeight:lang === 'tc' ? 800 : ''}}>繁體</div>
                        </div>
                        {!['/reservation'].includes(location.pathname) ? <a href={`https://book-directonline.com/properties/twentyonewhitfield`} target='_blank' className='relative book-now-bg flex flex-row items-center justify-center cursor-pointer select-none h-[31%]'>
                            <div className='relative book-text text-d-12 h-full rounded-full text-white font-[500] flex flex-row items-center justify-center w-[101px]' style={{zIndex:99}}>
                                {BTN.book_now[lang]}
                            </div>
                            <BookArrowSvg className='book-arrow absolute right-[-10%] bottom-0 two-k-scale-12' style={{zIndex:99}}/>
                            <BookArrowWhite className='book-arrow-white absolute right-[-10%] bottom-0 two-k-scale-12' style={{zIndex:98}}/>
                        </a> : <div style={{flex:1}}></div>}
                    </div>
                </div>
                {/* mobile */}
                <div className='absolute top-0 left-0 w-full h-full flex flex-row items-center justify-around d-hidden-m-show px-4'>
                    <div style={{flex:1}}>
                        <div className='flex flex-col items-center justify-center w-[44px] cursor-pointer select-none' onClick={() => handleSetRightNav(true)} style={{gap:4}}>
                            <div className='h-[1px] w-full bg-[#9D968D]'></div>
                            <div className='h-[1px] w-full bg-[#9D968D]'></div>
                            <div className='h-[1px] w-full bg-[#9D968D]'></div>
                        </div>
                    </div>
                    <div onClick={() => navigating(`/?lang=${lang}`)} className='h-full flex flex-row items-center justify-center cursor-pointer' style={{flex:1}}>
                        <div className='logo-size'>
                            <NewLogoTop />
                        </div>
                    </div>
                    <div style={{flex:1}}>
                        {/* {!['/reservation'].includes(location.pathname) ? <a href={`/reservation?lang=${lang}`} target='_blink'  className='relative book-now-bg flex flex-row items-center justify-center cursor-pointer select-none h-[30%]'>
                            <div className='relative book-text text-d-21 h-full rounded-full text-white font-[500] flex flex-row items-center justify-center w-[100px]' style={{zIndex:99}}>
                                Book Now
                            </div>
                            <BookArrowSvg className='book-arrow absolute right-[-10%] bottom-0' style={{zIndex:99}}/>
                            <BookArrowWhite className='book-arrow-white absolute right-[-10%] bottom-0' style={{zIndex:98}}/>
                        </a> : <div style={{flex:1}}></div>} */}
                    </div>
                </div>
            </div>
        </>
    );
};


export default connect((store)=>{
    return{
      control:store.controlReducer,
    }
  })(Nav)